import urlJoin from "url-join";

class Url {
  static getParameterByName(name, url, noDecode) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");

    const results = regex.exec(url);
    if (!results) return "";
    if (!results[2]) return "";
    if (noDecode) {
      return results[2].replace(/\+/g, " ");
    }
    try {
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    } catch {
      return results[2].replace(/\+/g, " ");
    }
  }

  /** Get the referral parameter with all url query parameters through to the
   * end of the url string.
   *
   * @param {string} url
   * @returns {string | null}
   */
  static getReferralParameter(url) {
    try {
      const results = /\?referral=(\S*$)/.exec(url);
      return results[1];
    } catch (e) {
      return null;
    }
  }

  static join() {
    return urlJoin(arguments);
  }

  static setCookie(cName, cValue, expiresDays) {
    const d = new Date();
    d.setTime(d.getTime() + expiresDays * 24 * 60 * 60 * 1000);
    const expires = d.toUTCString();
    const domain = window.location.hostname === "localhost" ? "localhost" : ".avetta.com";
    document.cookie = `${cName}=${cValue};expires=${expires};domain=${domain};path=/;SameSite=Strict`;
  }

  static getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}

export { Url as default };
